import { getServiceProvider } from '@takeshape/service-providers';
import { avatars, logos } from '../assets';
import { createServiceProvider } from '../util';

export default createServiceProvider({
  ...getServiceProvider('azureOpenai'),
  avatarPath: avatars.azureOpenai,
  logoPath: logos.azureOpenai
});
